export const BenefitIcon = () => (
    <svg
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="min-w-[56px]"
    >
        <g clipPath="url(#clip0_14143_332)">
            <rect
                width="56"
                height="56"
                fill="#313131"
            />
            <circle
                cx="28"
                cy="28"
                r="6"
                stroke="#F1F1F1"
                strokeWidth="2"
            />
            <ellipse
                cx="28.2843"
                cy="28.2844"
                rx="31.4662"
                ry="15"
                transform="rotate(-45 28.2843 28.2844)"
                stroke="#F1F1F1"
                strokeWidth="2"
            />
            <ellipse
                cx="31.4662"
                cy="15"
                rx="31.4662"
                ry="15"
                transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 61.1406 39.9277)"
                stroke="#F1F1F1"
                strokeWidth="2"
            />
        </g>
        <defs>
            <clipPath id="clip0_14143_332">
                <rect
                    width="56"
                    height="56"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
